import { render, staticRenderFns } from "./SearchOpenChannelPayments.vue?vue&type=template&id=76323bb8&"
import script from "./SearchOpenChannelPayments.vue?vue&type=script&lang=js&"
export * from "./SearchOpenChannelPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports